export const ANIMATION_DURATION = 0.3;
const ANIMATION_DURATION_MILLISECONDS = ANIMATION_DURATION * 1000;
export const HANDLE_SCROLL_TIMEOUT = ANIMATION_DURATION_MILLISECONDS * 2; // Temporarily disable the scroll handler
export const INITIAL_SEARCH_BAR_HEIGHT = 177;
